/**
 * Static Tailwind classes for Capacitor TopNavbar geometry.
 * CSS vars: `--capacitor-topnav-*` / `--capacitor-drawer-below-topnav-height`
 * in `layers/base/assets/css/main.css` `:root`.
 * Full class strings so Tailwind JIT can see them.
 */

/** `#main-scroll-root` top offset when TopNavbar is visible. */
export const CAPACITOR_TOPNAV_TOP_CLASS = 'top-(--capacitor-topnav-height)' as const

/** Same height as padding when TopNavbar is hidden (status-bar / cutout clearance). */
export const CAPACITOR_TOPNAV_HIDDEN_PAD_CLASS = 'top-0 pt-(--capacitor-topnav-height)' as const

/** TopNavbar header safe-area pad (CraneNavbar floor vs notch). */
export const CAPACITOR_TOPNAV_SAFE_PAD_CLASS = 'pt-(--capacitor-topnav-safe-pad)' as const

/**
 * AdaptiveDrawer sheet under TopNavbar (Capacitor). Include with the rest of
 * the drawer `content` classes.
 */
export const CAPACITOR_DRAWER_BELOW_TOPNAV_CONTENT_CLASS = [
    'mt-0 max-h-none h-(--capacitor-drawer-below-topnav-height)',
    'adaptive-drawer-content mx-auto rounded-t-[1.125rem] bg-(--neutral-50) overflow-hidden ring-0',
].join(' ')
